"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
// eslint-disable-next-line import/prefer-default-export
var SCOPE = exports.SCOPE = "scope";


//////////////////
// WEBPACK FOOTER
// ./~/cssapi/lib/const/scope.js
// module id = 338
// module chunks = 168707334958949